// `value` no formato devolvido por `user.features` (GET /users no
// server): número pra pacote de quantidade, `null` = ilimitado. Pra
// feature booleana, `null` ou `> 0` é liberado -- mesma regra de
// `ensurePlanFeature` no server, não pode divergir daqui. Reaproveitado
// tanto no gate de rota (`AuthRoute`) quanto em checagens inline dentro
// de uma página/menu.
const isFeatureGranted = (value: number | null | undefined): boolean =>
  value === null || (value !== undefined && value > 0);

export { isFeatureGranted };
